import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuickbooks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1403_28817)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
			fill: "#2CA01C"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.82078 19.9952C4.82238 24.5168 8.46878 28.1936 12.9904 28.2336H14.1472V25.2112H12.9904C10.1872 25.976 7.29598 24.3232 6.53278 21.52C6.52638 21.4976 6.52158 21.4752 6.51518 21.4528C5.72958 18.6128 7.37438 15.6704 10.2048 14.8528H10.7824C11.5072 14.6944 12.2576 14.6944 12.9824 14.8528H15.792V30.8992C15.7776 32.5968 17.1424 33.9856 18.84 34.0016V11.6752H13.008C8.45438 11.6992 4.78398 15.4096 4.80798 19.9632V19.9648L4.82078 19.9952ZM27.0208 11.6784H25.864V14.8608H27.0208C29.8176 14.0976 32.7024 15.7456 33.4656 18.5408C33.472 18.5616 33.4768 18.584 33.4832 18.6048C34.264 21.4352 32.624 24.3664 29.8048 25.1824H29.2272C28.5024 25.3408 27.752 25.3408 27.0272 25.1824H24.2176V9.13756C24.232 7.43996 22.8672 6.05116 21.1696 6.03516V28.3936H27.0016C31.5952 28.3216 35.2608 24.5408 35.1904 19.9472C35.12 15.4544 31.496 11.8288 27.0016 11.7584L27.0208 11.6784Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1403_28817",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgQuickbooks;
